import { render, staticRenderFns } from "./FrameView.vue?vue&type=template&id=be7d95f2"
import script from "./FrameView.vue?vue&type=script&lang=js"
export * from "./FrameView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports